"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var TextArea_1 = __importDefault(require("antd/lib/input/TextArea"));
var lodash_1 = require("lodash");
var noop_1 = __importDefault(require("lodash/noop"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
function TextAreaTd(props) {
    var _a = props.cell, colSpan = _a.colSpan, placeholder = _a.placeholder, path = _a.path, value = _a.value, rowSpan = _a.rowSpan;
    var style = props.style;
    var onChangeV = props.onValueUpdate;
    var isValueUndefined = (0, lodash_1.isNumber)(value) ? true : (value !== null && value !== void 0 ? value : '').trim() === '' || value === null || value === undefined;
    var displayError = props.required && isValueUndefined && props.triedSubmitting;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: __assign({}, style), className: index_modules_css_1.default.gridTd, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ className: "".concat(index_modules_css_1.default.gridFormItem, " ").concat(rowSpan > 1 ? index_modules_css_1.default.textareaGridContainer : ''), validateStatus: displayError ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsx)(TextArea_1.default, { style: {
                    width: '100%',
                    height: '100%',
                    background: 'transparent',
                    borderColor: displayError ? '#FF0000' : 'none',
                    padding: '10px',
                }, placeholder: placeholder, onChange: function (e) {
                    ;
                    (onChangeV || noop_1.default)(path, e.target.value);
                }, value: value !== null && value !== void 0 ? value : '' }) })) })));
}
exports.TextAreaTd = TextAreaTd;
